import { render } from "./PDFPreview.vue?vue&type=template&id=262b6f68&scoped=true&ts=true"
import script from "./PDFPreview.vue?vue&type=script&lang=ts"
export * from "./PDFPreview.vue?vue&type=script&lang=ts"

import "./PDFPreview.vue?vue&type=style&index=0&id=262b6f68&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262b6f68"]])

export default __exports__